import React, { useEffect, useState } from 'react'
import * as Styled from './WordCountPageByCountry.styled'
import WidgetLayout from 'pages/agenda-report-v4/detail/widgets/widget-layout'
import UpdateButton from 'pages/agenda-report-v4/detail/components/update-button/UpdateButton'
import { WordCountPageByCountryProps } from './types'
import { WordCount } from '../../widgets/types'
import WordCloud from '../../components/wordCloud/WordCloud'

const WordCountPageByCountry: React.FC<WordCountPageByCountryProps> = ({
  date,
  isEditValue,
  pageNumber,
  setIsEditValue,
  title,
  data,
  metaData,
}) => {
  const [wordCloudData, setWordCloudData] = useState<WordCount[] | undefined>(
    data
  )
  console.log('amcamrenderlandım:', data)
  const [pageData, setPageData] = useState<{
    title: string
    pageNumber: number
  }>({ title: title, pageNumber: pageNumber })

  const [editMode, setEditMode] = useState<boolean>(false)

  useEffect(() => {
    if (isEditValue === pageNumber) {
      setEditMode(true)
    }
  }, [isEditValue, pageNumber])

  useEffect(() => {
    if (isEditValue === -1) {
      setWordCloudData(data)
      setPageData({ title: title, pageNumber: pageNumber })
    }
  }, [isEditValue, data, title, pageNumber])

  const onChange = (key: string, value: string, source: string) => {
    setWordCloudData(
      wordCloudData?.map((item) => {
        if (item.Word === source) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    )
  }

  const onChangePageData = (key: string, value: string) => {
    setPageData({
      ...pageData,
      [key]: value,
    })
  }

  const editProps = {
    isEditValue: isEditValue,
    setIsEditValue: setIsEditValue,
    pageNumber: pageData.pageNumber,
    metaData,
  }

  return (
    <WidgetLayout
      asideDate={date}
      asideTitle={pageData.title}
      pageNumber={pageData.pageNumber}
      onChange={onChangePageData}
      editMode={editMode}
      flagShortCode={metaData?.flagShortCode}
    >
      <Styled.ContentContainer>
        <div className="edit-btn-container">
          <UpdateButton
            {...editProps}
            contentData={{ WordCounts: wordCloudData }}
            title={pageData?.title}
            editMode={editMode}
            setEditMode={setEditMode}
          />
        </div>
        <div>
          <WordCloud
            data={wordCloudData}
            setData={setWordCloudData}
            editMode={editMode}
            onChange={onChange}
          />
        </div>
      </Styled.ContentContainer>
    </WidgetLayout>
  )
}

export default WordCountPageByCountry
